import { refreshAuthToken } from "@/app/_actions/refreshAuthToken";

/**
 * Recover auth state after returning from Auth0 email verification. Tries a
 * silent token refresh first so new permissions land without a visible login
 * bounce; if there's no session to refresh, falls back to the login flow. Either
 * way the browser navigates with the refreshed cookie so both server components
 * and the client store pick up the new permissions.
 */
export async function recoverVerification(returnToPath: string): Promise<void> {
  if (typeof window === "undefined") return;
  // Only allow same-origin relative paths to avoid an open redirect if a future
  // caller passes an untrusted value (current callers pass window.location.pathname).
  const path = returnToPath.startsWith("/") && !returnToPath.startsWith("//") ? returnToPath : "/";
  const { success } = await refreshAuthToken();

  if (!success) {
    window.location.assign(`/auth/login?returnTo=${encodeURIComponent(path)}`);
    return;
  }

  window.location.assign(path);
}
